<div id="follow-mode-button" data-testid="follow-mode-btn" (click)="followModeOnClick()">
    <img [src]="getFollowModeIcon" alt="Center Map" />
</div>